module.exports = __webpack_public_path__ + "img/1.123435b7.png";